import { createAsyncThunk } from '@reduxjs/toolkit';
import { billingProcessService, medicalService, registerService } from 'services';

export const getFacilityByUser = createAsyncThunk<any, any>('receiving/a', async (param) => {
  try {
    const query = {
      page: 1,
      per_page: 1,
      conditions: [
        {
          id: 'facility_id',
          search_value: [param],
          exact_match: true,
          include_null: false,
        },
      ],
      use_display_id: true,
    };
    const { data } = await medicalService.getMedicals(query);
    return data.totalItems > 0 ? data.items[0] : null;
  } catch (error) {
    return null;
  }
});

export const registerBillReceive = createAsyncThunk<
  any,
  { facility_id: string; invoice_month: string; facility_name: string }
>('home/registerBillReceive', async (params) => {
  try {
    const invoice = await billingProcessService.getBillForFacility(params);

    const response = await registerService.getDataStoreFields({ dataStoreId: 't_invoice', appId: 'CPAP' });
    const result: any = Object.entries(response.data.fields)?.find(
      ([_key, value]: [string, any]) => value.display_id === 'editing_status_by_clinic',
    );

    if (invoice.data.items.length > 0 && result) {
      const statusEdit = result[1].options.find((f: any) => f.value === invoice.data.items[0].editing_status_by_clinic);
      if (invoice.data.items[0].Status === '請求書作成中' && statusEdit && statusEdit.display_id !== 'o_end') {
        const { data: invoiceUpdate } = await billingProcessService.updateInvoice({
          i_id: invoice.data.items[0].i_id,
          editing_status_by_clinic: 'o_editing',
        });
        return {
          item: invoiceUpdate ? { ...invoice.data.items[0], ...invoiceUpdate.item } : null,
          field_edit: result ? result[1].options : [],
        };
      }
      return { item: invoice ? invoice.data.items[0] : null, field_edit: result ? result[1].options : [] };
    }
    const { data }: any = await billingProcessService.registerNewBill({
      ...params,
      editing_status_by_clinic: 'o_editing',
    });
    const { data: newInvoice } = await billingProcessService.searchInvoice({
      per_page: 1,
      page: 1,
      conditions: [
        {
          id: 'i_id',
          search_value: [data.item.i_id],
          exact_match: true,
          include_null: false,
        },
      ],
    });
    return { item: newInvoice ? newInvoice.items[0] : null, field_edit: result ? result[1].options : [] };
  } catch (error: any) {
    return { item: null, field_edit: [] };
  }
});

export const getHospitals = createAsyncThunk<
  any,
  {
    invoice_month: string;
    facility_id: string;
    page: number;
    per_page: number;
    facilityId: string;
    valueSearch: string;
  }
>('home/getHospitals', async (params) => {
  try {
    const newHospitals = await billingProcessService.filterHospitalVisitandLinks({
      ...params,
      conditions: params.valueSearch
        ? [
            {
              id: 'patient_name',
              search_value: [params.valueSearch],
            },
          ]
        : undefined,
      return_id_value_results: true,
      include_item_ref: true,
      sort_fields: [
        {
          id: 'sort_num',
          order: 'asc',
        },
        {
          id: 'created_at',
          order: 'asc',
        },
      ],
    });
    const fields = await registerService.getDataStoreFields({ appId: 'CPAP', dataStoreId: 't_hospital_visit' });
    return {
      hospitals: {
        items: newHospitals.data.report_results,
        totalItems: newHospitals.data.totalItems,
      },
      fieldHospital: Object.entries(fields.data.fields),
    };
  } catch (error) {
    console.log(error);
  }
});

export const updateStatusOfClinic = createAsyncThunk<any, any>('home/updateStatusOfClinic', async (param) => {
  try {
    const { data } = await billingProcessService.updateInvoice({
      i_id: param.i_id,
      editing_status_by_clinic: 'o_end',
    });
    return data.item;
  } catch (error) {
    return null;
  }
});

export const updateBillingData = createAsyncThunk<any, any>('home/updateBillingData', async (param) => {
  try {
    const checkHospitalVisit = (text: string, options: any[]) => {
      const find = options.find((f) => f.value === text);

      if (find) {
        return find.display_id;
      }
      return text;
    };

    const related = param.hospitals.map((hos: any) => {
      let billing_type = undefined;
      const hospital = checkHospitalVisit(hos.hospital_visit, param.listOption);
      if (hospital === 'o_yes') {
        billing_type = 'o_normal';
      }
      if (hospital === 'o_no') {
        billing_type = 'o_unpaid';
      }

      const item: any = {
        hospital_visit: hos.hospital_visit,
      };
      if (billing_type) {
        item['billing_type'] = billing_type;
      }

      return {
        operation: 2,
        i_id: hos.i_id,
        item: item,
      };
    });
    const { data } = await billingProcessService.updateInvoice({
      i_id: param.i_id,
      related_ds_items: {
        t_hospital_visit: related,
      },
    });
    return data;
  } catch (error) {
    return error;
  }
});

export const getOptionInvoiceHeader = createAsyncThunk<any, any>('status/getOptionInvoiceHeader', async (params) => {
  try {
    const invoice = await billingProcessService.searchBills({
      page: 1,
      per_page: 0,
      conditions: [
        {
          id: 'facility_id',
          search_value: [params.facility_id],
          exact_match: true,
          include_null: false,
        },
      ],
      sort_field_id: 'invoice_month',
      sort_order: 'asc',
    });
    const options =
      invoice.data.items.length > 0
        ? invoice.data.items.map((v: any) => {
            return {
              value: v.invoice_month,
              name: `${v.invoice_month.slice(0, 4)}年${
                v.invoice_month.slice(4, 5).includes('1') ? v.invoice_month.slice(4) : v.invoice_month.slice(5)
              }月度`,
            };
          })
        : [];
    return options;
  } catch (error) {
    return [];
  }
});
